(function () {
  const divisionOverridesApp = function () {
    const preventFormSubmit = (e) => {
      window.stopEvent(e);

      const target = e.target;

      window.swalWithBootstrapButtons
        .fire({
          title: 'Are you sure?',
          text:
            'This will update division assignments and recreate pairings and tee groups from ' +
            'the selected start round through all future rounds without scores.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, continue!',
          cancelButtonText: 'No, cancel!',
          reverseButtons: true,
        })
        .then((result) => {
          if (!result.isConfirmed) return;

          $('.loader.generic-loader').removeClass('d-none');
          $(target).off('submit', preventFormSubmit);
          $(target).trigger('submit');
        });
    };

    const init = function () {
      if (!$('body').hasClass('controller-leagues-division_overrides')) return;

      const form = $('.division-overrides-form')[0];
      if (!form) return;

      $(form).on('submit', preventFormSubmit);
    };

    $(document).on('turbolinks:load', init);
  };

  if (typeof window !== 'undefined') {
    window.divisionOverridesApp = divisionOverridesApp();
  }

  return divisionOverridesApp;
})();
